import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable, Injector } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs';
import { ImageOverlayComponent } from './image-overlay.component';
import { IBbitImageOverlayParams, ImageOverlayRef } from './image-overlay.ref';

@Injectable({
  providedIn: 'root',
})
export class ImageOverlayService {
  private _overlayRef!: OverlayRef;
  constructor(
    private _overlay: Overlay,
    private _router: Router,
  ) {
    this._router.events.pipe(filter((event) => event instanceof NavigationStart)).subscribe((change) => {
      if (change instanceof NavigationStart) {
        this._overlayRef?.dispose();
      }
    });
  }

  public open(params: IBbitImageOverlayParams) {
    if ((params?.items?.length || 0) === 0) {
      return;
    }

    const positionStrategy = this._overlay.position().global().centerHorizontally().centerVertically();

    const overlayConfig = new OverlayConfig({
      hasBackdrop: true,
      backdropClass: 'overlay-backdrop',
      scrollStrategy: this._overlay.scrollStrategies.block(),
      positionStrategy,
      width: '95%',
      height: '95%',
    });

    this._overlayRef = this._overlay.create(overlayConfig);
    this._overlayRef.backdropClick().subscribe(() => this._overlayRef?.dispose());

    const imageOverlayRef = new ImageOverlayRef(this._overlayRef, params);
    const filePreviewPortal = new ComponentPortal(
      ImageOverlayComponent,
      null,
      Injector.create({
        providers: [{ provide: ImageOverlayRef, useValue: imageOverlayRef }],
      }),
    );
    this._overlayRef.attach(filePreviewPortal);
  }
}
